/* RESPONSIBLE TEAM: team-fin-voice */

export type KeyboardType = 'ipa' | 'cmu';
export type KeyboardTab = 'common' | 'vowels' | 'consonants' | 'stress';

// IPA Common — English-focused subset for quick access
export const IPA_COMMON_SYMBOLS: string[] = [
  'ə',
  'ɪ',
  'æ',
  'ʌ',
  'ɑ',
  'ɔ',
  'ʊ',
  'ɛ',
  'ŋ',
  'ʃ',
  'ʒ',
  'θ',
  'ð',
  'ɹ',
  'ˈ',
  'ˌ',
];

// IPA Vowels — full IPA vowel chart
export const IPA_VOWEL_SYMBOLS: string[] = [
  'i',
  'y',
  'ɨ',
  'ʉ',
  'ɯ',
  'u',
  'ɪ',
  'ʏ',
  'ʊ',
  'e',
  'ø',
  'ɘ',
  'ɵ',
  'ɤ',
  'o',
  'ə',
  'ɛ',
  'œ',
  'ɜ',
  'ɞ',
  'ʌ',
  'ɔ',
  'æ',
  'ɐ',
  'a',
  'ɶ',
  'ɑ',
  'ɒ',
  'aɪ',
  'aʊ',
  'ɔɪ',
  'eɪ',
  'oʊ',
];

// IPA Consonants — full IPA consonant chart
export const IPA_CONSONANT_SYMBOLS: string[] = [
  // Plosives
  'p',
  'b',
  't',
  'd',
  'ʈ',
  'ɖ',
  'c',
  'ɟ',
  'k',
  'g',
  'q',
  'ɢ',
  'ʔ',
  // Nasals, trills, taps, flaps
  'm',
  'ɱ',
  'n',
  'ɳ',
  'ɲ',
  'ŋ',
  'ɴ',
  'ʙ',
  'r',
  'ʀ',
  'ɾ',
  'ɽ',
  'ɸ',
  // Fricatives
  'β',
  'f',
  'v',
  'θ',
  'ð',
  's',
  'z',
  'ʃ',
  'ʒ',
  'ʂ',
  'ʐ',
  'ç',
  'ʝ',
  // Fricatives, lateral fricatives, approximants
  'x',
  'ɣ',
  'χ',
  'ʁ',
  'ħ',
  'ʕ',
  'h',
  'ɦ',
  'ɬ',
  'ɮ',
  'ʋ',
  'ɹ',
  'ɻ',
  // Approximants, lateral approximants
  'j',
  'ɰ',
  'l',
  'ɭ',
  'ʎ',
  'ʟ',
];

// CMU Vowels — sorted alphabetically
export const CMU_VOWEL_SYMBOLS: string[] = [
  'AA',
  'AE',
  'AH',
  'AO',
  'AW',
  'AY',
  'EH',
  'ER',
  'EY',
  'IH',
  'IY',
  'OW',
  'OY',
  'UH',
  'UW',
];

// CMU Consonants
export const CMU_CONSONANT_SYMBOLS: string[] = [
  'B',
  'CH',
  'D',
  'DH',
  'F',
  'G',
  'HH',
  'JH',
  'K',
  'L',
  'M',
  'N',
  'NG',
  'P',
  'R',
  'S',
  'SH',
  'T',
  'TH',
  'V',
  'W',
  'Y',
  'Z',
  'ZH',
];

// CMU Stress controls
export const CMU_STRESS_SYMBOLS: string[] = ['0', '1', '2'];

export function getSymbolsForTab(type: KeyboardType, tab: KeyboardTab): string[] {
  if (tab === 'common') {
    return IPA_COMMON_SYMBOLS;
  }
  if (tab === 'stress') {
    return CMU_STRESS_SYMBOLS;
  }

  if (tab === 'vowels') {
    return type === 'ipa' ? IPA_VOWEL_SYMBOLS : CMU_VOWEL_SYMBOLS;
  }

  return type === 'ipa' ? IPA_CONSONANT_SYMBOLS : CMU_CONSONANT_SYMBOLS;
}

export function getTabsForType(type: KeyboardType): KeyboardTab[] {
  if (type === 'ipa') {
    return ['common', 'vowels', 'consonants'];
  }
  return ['vowels', 'consonants', 'stress'];
}
